var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.$t('loading')))]):_vm._e(),_vm._v(" "),(_vm.deletedItem)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.deletedItem['@id'])+" deleted.")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a88ef2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/errors/ItemListErrors.vue
// module id = 496
// module chunks = 0